<div class="card p-4">
  <section class="d-flex space-between flex-align-items flex-wrap">
    <div class="d-flex flew-wrap flex-align-items">
      <h4 class="mr-2 mb-0">
        <app-go-back-button title="{{ 'returnToContractList' | translate }}" />
        {{ 'Contract.consumptionReport' | translate }} / {{ contract.name }}
      </h4>
      <app-badge-organization class="align-middle" [code]="contract.number"></app-badge-organization>
      <div class="p-1">
        <label>Nb mois :&nbsp;</label>
        <select [(ngModel)]="nbMonth" (change)="refreshData()">
          <option [ngValue]="12">12</option>
          <option [ngValue]="24">24</option>
        </select>
      </div>
      <button class="btn btn-sm btn-primary ml-2" [routerLink]="['../']">
        <i class="icofont icofont-edit-alt mr-1" title="{{ 'Edit' | translate }}"></i>
        {{ 'Edit' | translate }}
      </button>
    </div>
  </section>

  <hr />

  <app-contract-filters-actionbar
    [filterValues]="filterValues"
    [multiple]="[]"
    (onSelect)="this.onChangeFilter($event)"
  />

  <app-contract-graphs class="mt-4" [contract]="contract" [invoicingBuckets]="invoicingReport" />
</div>
